import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "./store";
Vue.use(VueI18n);

// The getters are to be called in the way below only when Map Datastructure is used.
let getHomepageEn = () => {
  return store.getters.getHomepage.filter((page) => page.locale === "en");
};

let getHomepageEs = () => {
  return store.getters.getHomepage.filter((page) => page.locale === "es-US");
};

// Getters for Faq Category -> English Language
let getFaqCategoriesEn = () => {
  return store.getters.getFaqCategories.filter((cat) => cat.locale === "en");
};

let getFaqCategoriesEs = () => {
  return store.getters.getFaqCategories.filter((cat) => cat.locale === "es-US");
};

let getFaqsEn = () => {
  return store.getters.getFaqs.filter((faq) => faq.locale === "en");
};

let getFaqsWithUrlEn = () => {
  console.log(store.getters.getFaqsWithUrl);
  return store.getters.getFaqsWithUrl.filter((faq) => faq.locale === "en");
};

let getFaqsWithUrlEs = () => {
  console.log(store.getters.getFaqsWithUrl);
  return store.getters.getFaqsWithUrl.filter((faq) => faq.locale === "es-US");
};

let getFaqsEs = () => {
  return store.getters.getFaqs.filter((faq) => faq.locale === "es-US");
};

let getFloorsEn = () => {
  return store.getters.getFloors.filter((floor) => floor.locale === "en");
};

let getFloorsEs = () => {
  return store.getters.getFloors.filter((floor) => floor.locale === "es-US");
};

// Getters for Maps -> English Language
let getMapsEn = () => {
  let temp = [];
  store.getters.getMaps.forEach((map) => {
    if (map.locale === "en") {
      temp.push(map);
    }
  });
  return temp;
};

let getMapsEs = () => {
  let temp = [];
  store.getters.getMaps.forEach((map) => {
    if (map.locale === "es-US") {
      temp.push(map);
    }
  });
  return temp;
};

let getFormCategoriesEn = () => {
  return store.getters.getFormCategories.filter(
    (category) => category.locale === "en"
  );
};

let getFormCategoriesEs = () => {
  return store.getters.getFormCategories.filter(
    (category) => category.locale === "es-US"
  );
};

let getQnaEn = () => {
  console.log(store.getters.getQnaEndpointEN.kbName, "check this ");
  return store.getters.getQnaEndpointEN.kbName;
};
let getQnaEs = () => {
  return store.getters.getQnaEndpointES.kbName;
};

let getFormsEn = () => {
  let temp = [];
  store.getters.getForms.forEach((form) => {
    if (form.locale === "en") {
      temp.push(form);
    }
  });
  return temp;
};

let getFormsEs = () => {
  let temp = [];
  store.getters.getForms.forEach((form) => {
    console.log(form, "This are forms");
    console.log(form.locale, "This is locale");
    if (form.locale === "es-US") {
      temp.push(form);
    }
  });
  return temp;
};

let getDepartmentsEn = () => {
  return store.getters.getDepartments.filter(
    (depart) => depart.locale === "en"
  );
};

let getDepartmentsEs = () => {
  return store.getters.getDepartments.filter(
    (depart) => depart.locale === "es-US"
  );
};

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",

  messages: {
    en: {
      // Homepage
      homepages: getHomepageEn,

      // Faqs
      faqs: getFaqsEn,
      faqsWithUrl: getFaqsWithUrlEn,

      faqCategory: getFaqCategoriesEn,

      // Maps
      maps: getMapsEn,
      floors: getFloorsEn,

      // Forms
      formCategory: getFormCategoriesEn,
      forms: getFormsEn,

      departments: getDepartmentsEn,

      qnaEndpoint: getQnaEn,
      followUpQuestionsDRO:
        "What does Expungement mean?,Where is Hearing Room A?,Where is Domestic Relations Training Room?",
      followupQuestionJC:
        "What does Expungement mean?,How do I make payments?,I need Civil Complaint form,Where is Hearing Room A?,Where is Cafe?, I need complaint for Support Form.",
      followupQuestionMDJ:
        "How can I pay a non-traffic citation?,What does Expungement mean?,What do I need to file a civil complaint?",
      followUpQuestionsDHS:"Where is Health Clinic?,Where is Planning Commisioner's Office?,Where is the Cafe?,I need Human Service Assistance",
      currentLang: "en",
      kbError:
        "Sorry I am still learning. Please visit someone at the window for assistance.",
      defaultKBError:
        "Sorry I am still learning. Please visit the Court Administration Office for more Information.",
      defaultDHSKBError:
        "Sorry I am still learning. Please visit the Human Services Reception 128 for more Information.",
      outsideError:
        "Sorry I am still learning. Please see someone at the Counter",
      mapNotFound:
        "Sorry, I can't find the requested location, please go to the Court Administrator's Office for more information.",
      formNotFound:
        "Sorry, I can't find the requested form, please go to the Law Library for more information.",
      selectOptionMsg:
        "Tap on the below, or click on the microphone to ask another question.",
      bubbletextafteraction:
        "Tap on the microphone button, and ask a court or county related question.",
      defaultfloor: "Floor",
      paymentPopupMsg: "Please select the type of Payment.",
      bubbletextonBack: "Please tap one of the options below.",
      qnaResponses: {
        mapResponse: "You’ll find the requested location map in the popup.",
        formResponse:"You’ll find the requested form in the popup.",
        payInfo:"You’ll find the requested payment information in the popup.",
        redirectInfo:"You are getting redirected to a external website.",
        faqInfo:"You can read more information on the left.",
        followUpInfo:"You will see a set of example questions in the popup",
        infoNotFound:"I couldn't find the information you're looking for. Please try rephrasing your question."
      },
    },
    es: {
      //Homepage
      homepages: getHomepageEs,
      // Faqs
      faqs: getFaqsEs,
      faqsWithUrl: getFaqsWithUrlEs,
      faqCategory: getFaqCategoriesEs,

      // Maps
      maps: getMapsEs,
      floors: getFloorsEs,

      // Forms
      formCategory: getFormCategoriesEs,
      forms: getFormsEs,

      departments: getDepartmentsEs,

      qnaEndpoint: getQnaEs,
      followUpQuestionsDRO:
        "¿Qué significa eliminación de antecedentes penales?,¿Dónde está la Sala de Audiencias A?,¿Dónde está la Sala de Capacitación en Relaciones Domésticas?",
      followupQuestionJC:
        "¿Qué significa eliminación de antecedentes penales?,¿Cómo hago los pagos?,Necesito formulario de Queja Civil,¿Dónde está la Sala de Audiencias A?,¿Dónde está Café?,Necesito una queja para el Formulario de Soporte.",
      followupQuestionMDJ:
        "¿Qué significa eliminación de antecedentes penales?,¿Cómo puedo pagar una citación no relacionada con el tráfico?,¿Qué necesito para presentar una demanda civil?",

      currentLang: "es-US",
      kbError:
        "Lo siento, todavía estoy aprendiendo. Visite a alguien en la ventana para obtener ayuda.",
      defaultKBError:
        "Lo siento, todavía estoy aprendiendo. Visite la Oficina de Administración del Tribunal para obtener más información.",
      outsideError:
        "Lo siento, todavía estoy aprendiendo. Por favor, consulte a alguien en el mostrador.",
      mapNotFound:
        "Lo siento, no puedo encontrar la ubicación solicitada, por favor diríjase a la Oficina del Administrador del Tribunal para obtener más información.",
      formNotFound:
        "Lo siento, no puedo encontrar el formulario solicitado, vaya a la Biblioteca de Derecho para obtener más información.",
      selectOptionMsg:
        "Toque a continuación o haga clic en el micrófono para hacer otra pregunta.",
      bubbletextafteraction:
        "Toque el botón del micrófono y haga una pregunta relacionada con el tribunal o el condado.",
      defaultfloor: "Piso",
      paymentPopupMsg: "Por favor seleccione el tipo de pago",
      qnaResponses: {
        mapResponse: "Encontrará el mapa de ubicación solicitado en la ventana emergente.",
        formResponse:"Encontrará el formulario solicitado en la ventana emergente.",
        payInfo:"Encontrará la información de pago solicitada en la ventana emergente.",
        redirectInfo:"Estás siendo redirigido a un sitio web externo.",
        faqInfo:"Puedes leer más información a la izquierda.",
        followUpInfo:"Verá un conjunto de preguntas de ejemplo en la ventana emergente.",
        infoNotFound:"No encontré la información que buscas. Intenta reformular tu pregunta."
      },
    },
  },
});
